import React from 'react'
import ProductBanner from '../Components/productsection/ProductBanner'

function Products() {
  return (
   <>
   <ProductBanner />
   </>
  )
}

export default Products